import React, { useEffect } from 'react';

export function AddressTab({
  blkLot,
  street,
  barangay,
  city,
  municipality,
  postalCode,
  yearsOfStay,
  setBlkLot,
  setStreet,
  setBarangay,
  setCity,
  setMunicipality,
  setPostalCode,
  setYearsOfStay,

  dateEmployed, // <---- added for Automated Year of Stay

  isEditMode,
}) {
  useEffect(() => {
    if (!dateEmployed) {
      setYearsOfStay(0);
      return;
    }

    const hireDate = new Date(dateEmployed);
    const today = new Date();

    let years = today.getFullYear() - hireDate.getFullYear();

    const anniversaryPassed =
      today.getMonth() > hireDate.getMonth() ||
      (today.getMonth() === hireDate.getMonth() &&
        today.getDate() >= hireDate.getDate());

    if (!anniversaryPassed) {
      years--;
    }

    console.log("TEST") 

    setYearsOfStay(Math.max(0, years));
  }, [dateEmployed, setYearsOfStay]);

  return (
    <div className="address-tab column">
      <div className="address-tab-itemHolder info-item-holder row">
        <div className="info-item info-item3 column">
          <div className="info-item-label">Blk/Lot</div>
          <div className="info-item-input">
            <input id="AddEmployee-BlkLot" placeholder="Blk/Lot"
              readOnly={!isEditMode} value={blkLot} onChange={(e) => setBlkLot(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Street</div>
          <div className="info-item-input">
            <input id="AddEmployee-Street" placeholder="Street"
              readOnly={!isEditMode} value={street} onChange={(e) => setStreet(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Barangay</div>
          <div className="info-item-input">
            <input id="AddEmployee-Barangay" placeholder="Barangay"
              readOnly={!isEditMode} value={barangay} onChange={(e) => setBarangay(e.target.value)}
            /></div>
        </div>
      </div>
      <div className="address-tab-itemHolder info-item-holder row">
        <div className="info-item info-item3 column">
          <div className="info-item-label">City</div>
          <div className="info-item-input">
            <input id="AddEmployee-City" placeholder="City"
              readOnly={!isEditMode} value={city} onChange={(e) => setCity(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Municipality</div>
          <div className="info-item-input">
            <input id="AddEmployee-Municipality" placeholder="Municipality" maxLength={20}
              readOnly={!isEditMode} value={municipality} onChange={(e) => setMunicipality(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Postal Code</div>
          <div className="info-item-input">
            <input id="AddEmployee-PostalCode" placeholder="Postal Code" maxLength={10}
              readOnly={!isEditMode} value={postalCode} onChange={(e) => setPostalCode(e.target.value)}
            /></div>
        </div>
      </div>
      <div className="address-tab-itemHolder info-item-holder row">
        <div className="info-item info-item3 column">
          <div className="info-item-label">Years Of Stay</div>
          <div className="info-item-input">
            <input id="AddEmployee-YearsOfStay" type="number" placeholder="Years Of Stay"
              readOnly={!isEditMode} value={yearsOfStay} onChange={(e) => setYearsOfStay(e.target.value)}
            /></div>
        </div>
      </div>
    </div>
  )
}